import Axios from "../config/config";
export const LMS_STORAGE = '#';

export const LOGIN_API = async (body) => {
    try {
        const response = await Axios.post('login/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LOGOUT_API = async (body) => {
    try {
        const response = await Axios.post('logout/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const PHISHING_DASHBOARD = async (body) => {
    try {
        const response = await Axios.post('phishing-dashboard/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};





//SMTP APIS.....
export const LIST_SMTP = async (body) => {
    try {
        const response = await Axios.post('smtp-list/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const ADD_SMTP = async (body) => {
    try {
        const response = await Axios.post('add-smtp/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const EDIT_SMTP = async (body) => {
    try {
        const response = await Axios.post('edit-smtp/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const VIEW_SMTP = async (body) => {
    try {
        const response = await Axios.post('view-smtp/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const SMTP_STATUS = async (body) => {
    try {
        const response = await Axios.post('smtp-status/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const DELETE_SMTP = async (body) => {
    try {
        const response = await Axios.post('delete-smtp/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

//USER APIS 

export const BULD_USER_IMPORT_TEMPLATE = async (body) => {
  try {
    const response = await Axios.post( 'bulk-user-import-template/',body,
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const ADD_USER = async (body) => {
    try {
        const response = await Axios.post('add-user/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const EDIT_USER  = async (body) => {
    try {
        const response = await Axios.post('edit-user/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const VIEW_USER  = async (body) => {
    try {
        const response = await Axios.post('view-user/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const LIST_USER  = async (body) => {
    try {
        const response = await Axios.post('user-list/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const USER_CAMP  = async (body) => {
    try {
        const response = await Axios.post('get-user-campaign-details/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LIST_CAMPAIGN_USER  = async (body) => {
    try {
        const response = await Axios.post('list-campaign-user/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LIST_DEPARTMENTS  = async (body) => {
    try {
        const response = await Axios.post('list-departments/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};



export const USER_STATUS  = async (body) => {
    try {
        const response = await Axios.post('user-status/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};



//EMAIL TEMPLATE APIS

export const ADD_EMAIL  = async (body) => {
    try {
        const response = await Axios.post('add-email/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const EDIT_EMAIL  = async (body) => {
    try {
        const response = await Axios.post('edit-email/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const VIEW_EMAIL  = async (body) => {
    try {
        const response = await Axios.post('view-email/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LIST_EMAIL  = async (body) => {
    try {
        const response = await Axios.post('list-email/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};
export const DELETE_EMAIL  = async (body) => {
    try {
        const response = await Axios.post('delete-email/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const COPY_EMAIL  = async (body) => {
    try {
        const response = await Axios.post('copy-email/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const ADD_LANDING  = async (body) => {
    try {
        const response = await Axios.post('add-landing/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const EDIT_LANDING  = async (body) => {
    try {
        const response = await Axios.post('edit-landing/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const VIEW_LANDING  = async (body) => {
    try {
        const response = await Axios.post('view-landing/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};



export const LIST_LANDING_PAGE  = async (body) => {
    try {
        const response = await Axios.post('list-landing-page/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const DELETE_LANDING  = async (body) => {
    try {
        const response = await Axios.post('delete-landing/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const CREATE_GROUP  = async (body) => {
    try {
        const response = await Axios.post('create-group/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LIST_GROUP  = async (body) => {
    try {
        const response = await Axios.post('list-group/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const EDIT_GROUP  = async (body) => {
    try {
        const response = await Axios.post('edit-group/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const VIEW_GROUP  = async (body) => {
    try {
        const response = await Axios.post('view-group/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const VIEW_GROUP_SELECTED  = async (body) => {
    try {
        const response = await Axios.post('view-group-selected/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const DELETE_USER_GROUP  = async (body) => {
    try {
        const response = await Axios.post('delete-user-group/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};



export const ADD_CAMPAIGN = async (body) => {
    try {
        const response = await Axios.post('add-campaign/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const LIST_COURSE = async (body) => {
    try {
        const response = await Axios.post('list-course/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};



export const LIST_CAMPAIGN = async (body) => {
    try {
        const response = await Axios.post('list-campaign/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const DOWNLOAD_CAMPAIGN = async (body) => {
    try {
        const response = await Axios.post('download-campaign/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LIST_CAMPAIGN_REPORT = async (body) => {
    try {
        const response = await Axios.post('list-campaign-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const REPEAT_OFFENDER_DASHBOARD = async (body) => {
    try {
        const response = await Axios.post('repeat-offender-dashboard/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};



export const DOWNLOAD_OFFENDER_REPORT = async (body) => {
    try {
        const response = await Axios.post('download-offender-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const EXPORT_DOWNLOAD_REPORT = async (body) => {
    try {
        const response = await Axios.post('export-download-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const DELETE_CAMPAIGN_OFFENDER_REPORT= async (body) => {
    try {
        const response = await Axios.post('delete-campaign-offender-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};



export const DELETE_REPORT= async (body) => {
    try {
        const response = await Axios.post('delete-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const LIST_OFFENDER_REPORT = async (body) => {
    try {
        const response = await Axios.post('list-offender-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

//DELETED REPORT API

export const LIST_DELETED_OFFENDER_REPORT = async (body) => {
    try {
        const response = await Axios.post('list-deleted-offender-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LIST_DELETED_CAMPAIGN_REPORT = async (body) => {
    try {
        const response = await Axios.post('list-deleted-campaign-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};




export const SOFT_DELETE = async (body) => {
    try {
        const response = await Axios.post('delete-campaign/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};



export const CAMPAIGN_TRACKING = async (body) => {
    try {
        const response = await Axios.post('campaign-tracking/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const BULK_ADD_USER = async (body) => {
    try {
        const response = await Axios.post('bulk-add-user/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LIST_IMPORT_USER = async (body) => {
    try {
        const response = await Axios.post('list-import-user/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const IMPORT_TRACKING_LIST = async (body) => {
    try {
        const response = await Axios.post('import-tracking-list/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};



export const TOOL_SETTING = async (body) => {
    try {
        const response = await Axios.post('tool-setting-view/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

//LMS LEARNER API 

export const CREATE_LEARNER_GROUP = async (body) => {
    try {
        const response = await Axios.post('create-learner-group/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const EDIT_LEARNER_GROUP = async (body) => {
    try {
        const response = await Axios.post('edit-learner-group/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const LIST_LEARNER_GROUP = async (body) => {
    try {
        const response = await Axios.post('list-learner-group/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const VIEW_LEARNER_GROUP = async (body) => {
    try {
        const response = await Axios.post('view-learner-group/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LEARNER_LIST = async (body) => {
    try {
        const response = await Axios.post('learner-list/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};




export const CAMPAIGN_SUMMARY = async (body) => {
    try {
        const response = await Axios.post('campaign-summary/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const REPEAT_OFFENDER_SUMMARY = async (body) => {
    try {
        const response = await Axios.post('repeat-offender-summary/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const DEPARTMENT_RISK_HEATMAP = async (body) => {
    try {
        const response = await Axios.post('department-risk-heatmap/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const HUMAN_RISK_SCORECARD = async (body) => {
    try {
        const response = await Axios.post('human-risk-scorecard/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const UPDATE_ADMIN_PROFILE = async (body) => {
    try {
        const response = await Axios.post('update-admin-profile/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const POPULATE_USER_RISK_SCORE = async (body) => {
    try {
        const response = await Axios.post('populate-user-risk-score/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

